import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import LoadingScreen from "./Componentes/Bienvenida/Bienvenida.js";
import Login from "./Componentes/Login/login.js";
import Registro from "./Componentes/Registro/Registro.js";
import Carta from "./Componentes/Carta/carta.js";
import Recomendaciones from "./Componentes/Carta/Recomendaciones.js";
import PanelAdministrador from "./Componentes/Administrador/PanelAdministrador.js";
import EditarPerfil from "./Componentes/Perfil/EditarPerfil.js";
import Pagina404 from "./Componentes/404/Pagina404.js";
import Favoritos from "./Componentes/Carta/Favoritos.js";
import HistorialPedidos from "./Componentes/Carta/HistorialPedidos.js";
import OnboardingScreen from "./Componentes/Carta/OnboardingScreen";
import Prueba from "./Componentes/Carta/PruebaScroll.js";
import Register from "./Componentes/Registro/RegistroNuevo.js";
import Reservas from "./Componentes/Carta/Reservas";

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<LoadingScreen />} />
        <Route path="/registro" element={<Register />} />
        <Route path="/login" element={<Login />} />
        <Route path="/carta" element={<Carta />} />
        <Route path="/recomendaciones" element={<Recomendaciones />} />
        <Route
          path="/recomendaciones/compartido/:id"
          element={<Recomendaciones />}
        />
        <Route path="/ultimos_pedidos" element={<HistorialPedidos />} />
        <Route path="/paneladministrador" element={<PanelAdministrador />} />
        <Route path="/editar_perfil" element={<EditarPerfil />} />
        <Route path="/favoritos" element={<Favoritos />} />
        <Route path="/historialpedidos" element={<HistorialPedidos />} />
        <Route path="/onboarding" element={<OnboardingScreen />} />
        <Route path="/prueba" element={<Prueba />} />
        <Route path="/register" element={<Register />} />
        <Route path="*" element={<Pagina404 />} />
        <Route path="/reservas" element={<Reservas />} />
      </Routes>
    </Router>
  );
}

export default App;
